import React from 'react'
import { StyleSheet } from 'react-native'

import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

const styles = StyleSheet.create({
  text: { marginTop: 12 },
})

export const UpscorePageFooter = () => (
  <>
    <Title black size='sm'>
      Upscore Details
    </Title>
    <Text fontSize='sm' style={styles.text}>
      Your Upscore measures your activity over the past 30 days. The more activities completed or
      shared, the higher your Upscore. It is a continously rolling 30 days, meaning your activity
      from 31 days ago does not count towards this score.
    </Text>
  </>
)
